import { useEffect, useRef, useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { Loader2 } from "lucide-react";
import { api, errMsg } from "../lib/api";
import { RegisterForm } from "../components/RegisterForm";

export default function VerifyEmail() {
  const [params] = useSearchParams();
  const [reg, setReg] = useState(null);
  const [error, setError] = useState("");
  const sent = useRef(false);
  useEffect(() => {
    const token = params.get("token");
    if (!token) { setError("Lien incomplet"); return; }
    if (sent.current) { return; }
    sent.current = true;
    api.post("/auth/verify-email", { token }).then((r) => setReg(r.data)).catch((e) => setError(errMsg(e)));
  }, [params]);
  if (reg) return <RegisterForm reg={reg} />;
  return (
    <div className="min-h-screen grid place-items-center p-6">
      <div className="tl-card max-w-md w-full text-center space-y-4" data-testid="verify-email">
        {error ? <p className="text-sm text-red-700" data-testid="verify-error">{error}</p> : <Loader2 className="animate-spin mx-auto" />}
        {error && <Link to="/inscription" className="tl-btn tl-btn-primary w-full" data-testid="verify-restart">Recommencer l'inscription</Link>}
      </div>
    </div>
  );
}
